const formattedNumber = {
  props:{
    lang: {default: 'el'},
    value: {default: 0, type: Number},
    float: {default: 2, type: Number},
    noFloatAtZero: {default: false} // if true, then when value is 0, will not be floated even if the float is above 0
  },
  template:`<span class="formatted-number">{{formattedValue}}</span>`,
  methods:{
    stringifyPrice(value){
      return value.toLocaleString(this.lang, {
          minimumFractionDigits: this.float,
          maximumFractionDigits: this.float
      })
    }
  },
  computed:{
    formattedValue(){
      if(this.noFloatAtZero && this.value===0){
        return 0
      }
      return this.stringifyPrice(this.value)
    }
  }
}